/**
 * Helpers for Search tab back/forward: commit only when query/path differ.
 */

export type SearchHistorySnapshot = {
  searchQuery?: string
  searchPath?: string
}

export function normalizeSearchHistoryQuery(query: string | null | undefined): string {
  return (query ?? '').trim()
}

export function normalizeSearchHistoryPath(path: string | null | undefined): string {
  return (path ?? '').trim()
}

/** True when the next committed search differs from the current history entry. */
export function shouldCommitSearchQuery(
  current: SearchHistorySnapshot | null | undefined,
  nextQuery: string,
  nextPath?: string | null,
): boolean {
  const q = normalizeSearchHistoryQuery(nextQuery)
  const p = normalizeSearchHistoryPath(nextPath)
  const curQ = normalizeSearchHistoryQuery(current?.searchQuery)
  const curP = normalizeSearchHistoryPath(current?.searchPath)
  return q !== curQ || p !== curP
}

/** Build /search URL for history restore (q + path only). */
export function buildSearchHistoryUrl(
  searchQuery?: string | null,
  searchPath?: string | null,
): string {
  const params = new URLSearchParams()
  const q = normalizeSearchHistoryQuery(searchQuery)
  const path = normalizeSearchHistoryPath(searchPath)
  if (q) params.set('q', q)
  if (path) params.set('path', path)
  const qs = params.toString()
  return qs ? `/search?${qs}` : '/search'
}
